import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-400 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=unchecked]:bg-zinc-900 data-[state=unchecked]:border-zinc-700 data-[state=unchecked]:shadow-[inset_0_2px_4px_rgba(0,0,0,0.3)]",
      "data-[state=checked]:bg-gradient-to-br data-[state=checked]:from-zinc-600 data-[state=checked]:to-zinc-700 data-[state=checked]:border-zinc-500 data-[state=checked]:shadow-[0_0_0_1px_rgba(255,255,255,0.2),0_2px_8px_rgba(255,255,255,0.1),inset_0_1px_2px_rgba(255,255,255,0.15)]",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full transition-all duration-200",
        "bg-gradient-to-br from-zinc-200 to-zinc-300",
        "shadow-[0_2px_4px_rgba(0,0,0,0.4),0_0_0_1px_rgba(255,255,255,0.3)]",
        "data-[state=checked]:translate-x-5 data-[state=checked]:shadow-[0_0_0_1px_rgba(255,255,255,0.4),0_4px_8px_rgba(255,255,255,0.2),0_2px_4px_rgba(0,0,0,0.5)]",
        "data-[state=unchecked]:translate-x-0"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
